var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtherIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.70166,
    y: 1.5,
    width: 49,
    height: 49,
    rx: 24.5,
    stroke: "#278DEC",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2015 28.1663C27.3981 28.1663 28.3682 27.1963 28.3682 25.9997C28.3682 24.8031 27.3981 23.833 26.2015 23.833C25.0049 23.833 24.0348 24.8031 24.0348 25.9997C24.0348 27.1963 25.0049 28.1663 26.2015 28.1663Z",
    fill: "#278DEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3682 28.1663C42.5648 28.1663 43.5348 27.1963 43.5348 25.9997C43.5348 24.8031 42.5648 23.833 41.3682 23.833C40.1715 23.833 39.2015 24.8031 39.2015 25.9997C39.2015 27.1963 40.1715 28.1663 41.3682 28.1663Z",
    fill: "#278DEC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0348 28.1663C12.2314 28.1663 13.2015 27.1963 13.2015 25.9997C13.2015 24.8031 12.2314 23.833 11.0348 23.833C9.83821 23.833 8.86816 24.8031 8.86816 25.9997C8.86816 27.1963 9.83821 28.1663 11.0348 28.1663Z",
    fill: "#278DEC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2015 28.1663C27.3981 28.1663 28.3682 27.1963 28.3682 25.9997C28.3682 24.8031 27.3981 23.833 26.2015 23.833C25.0049 23.833 24.0348 24.8031 24.0348 25.9997C24.0348 27.1963 25.0049 28.1663 26.2015 28.1663Z",
    stroke: "#278DEC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3682 28.1663C42.5648 28.1663 43.5348 27.1963 43.5348 25.9997C43.5348 24.8031 42.5648 23.833 41.3682 23.833C40.1715 23.833 39.2015 24.8031 39.2015 25.9997C39.2015 27.1963 40.1715 28.1663 41.3682 28.1663Z",
    stroke: "#278DEC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0348 28.1663C12.2314 28.1663 13.2015 27.1963 13.2015 25.9997C13.2015 24.8031 12.2314 23.833 11.0348 23.833C9.83821 23.833 8.86816 24.8031 8.86816 25.9997C8.86816 27.1963 9.83821 28.1663 11.0348 28.1663Z",
    stroke: "#278DEC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherIcons);
export default __webpack_public_path__ + "static/media/otherIcons.2c9f66051a1e71d8ccc3165d55bfa034.svg";
export { ForwardRef as ReactComponent };